module.exports = __webpack_public_path__ + "img/26.18e96014.png";